<template>
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading client individual ...
        </div>
        <div class="notification is-danger" v-if="loading === false && client_individual.id == 0">
            Client Individual details cannot be found
        </div>

        <div v-if="loading == false && client_individual.id > 0">
            <h4 class="title is-size-4">Client Individual Details <span class="tag is-warning" v-if="this.client_individual.hide_client==1"> Hidden</span></h4>
            <form @submit.prevent="updateClientIndividual()">
                
                
                <div class="field ">
                    <div class="columns">
                        <div class="column">
                            <label class="label">Forename</label>
                            <div class="control columns" >
                                <div class="column"><input class="input" type="text" v-model="client_individual.forename"  ></div>
                               
                            </div>
                        </div>
                        <div class="column">
                            <label class="label">Surname</label>
                            <div class="control columns" >
                                <div class="column"><input class="input" type="text" v-model="client_individual.surname"  ></div>
                               
                            </div>
                        </div>
                       
                    </div>

                    
                </div>
                

                <div class="columns">
                    <div class="column">
                        <label class="label">Date of Birth</label>
                        <div class="control columns" >
                            <div class="column">
                                <input class="input" type="date" v-model="client_individual.dob"  >
                            </div>
                            
                        </div>
                    </div>
                    <div class="column">
                       
                    </div>
                    
                </div>

                <div class="field is-grouped" v-if="this.user.billing==1"><div class="control"><button type="submit" class="button is-success" >Update Individual Details</button></div></div>
            </form>
            
            <hr />
            <h4 class="title is-size-4">Documents</h4>
            <div class="notification is-danger" v-if="client_individual.documents.length == 0">
                No documents can be found for this individual
            </div>
            <table class="table is-fullwidth is-striped is-hoverable" v-if="client_individual.documents.length > 0">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Version</th>
                        <th>Date/Time Added</th>
                        <th width="100">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in client_individual.documents" :key="row.id">
                        <td>{{ row.name }}</td>
                        <td>{{ row.version }}</td>
                        <td>{{ row.date_added }}</td>
                        <td><button class="button is-small is-success" @click="uploadNewVersion(row.name, row.version, row.id)">Upload New Version</button></td>
                    </tr>
                
                </tbody>

            </table>

            <button class="button is-small is-success" @click="showNewDocumentModal()">Add New Document</button>

            

            <div class="modal" :class="{'is-active': showModal==true}">
                <div class="modal-background"></div>
                <div class="modal-card" >
                    <form @submit.prevent="saveDocument()">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Add A New Document</p>
                        <button class="delete" aria-label="close" @click="closeModal()"></button>
                    </header>
                    <section class="modal-card-body " >
                        
                        <div class="field">
                            <label class="label">Document Name</label>
                            <div class="control">
                                <input class="input" type="text" v-model="name" required >
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Version</label>
                            <div class="control">
                                <input class="input" type="number" v-model="version" readonly >
                                
                            </div>
                        </div>
                        
                        
                    </section>
                    
                    <footer class="modal-card-foot" >
                    <button type="submit" class="button is-success" :disabled="working==true">Save Document</button>
                    <button type="button" class="button" @click="closeModal()" :disabled="working==true">Cancel</button>
                    </footer>
                </form>
                </div>
                
            </div>

           
        </div>

        
    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import BookingService from '@/services/BookingService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'ClientGroups',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   client_individual: [],
                   loading: true,
                   working: false,
                   accessToken: '',
                   showModal: false,
                   client_groups: [],
                   client_group_billing_profiles: [],
                   user: [{billing: 0}],
                   
                    name: '',
                    version:1,
                    previous_document_id: 0
            }
        },
        methods: {
            async getClientIndividual() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "client_individuals/" + this.$route.params.id)
                .then(
                    (client_individual => {
                        this.$set(this, "client_individual", client_individual);

                        this.loading=false
                    }).bind(this)
                );

                this.forename = ''
                this.surname= ''
                this.dob= ''

            },
            showNewDocumentModal() {
                this.showModal = true
                 this.previous_document_id = 0
            },
            uploadNewVersion(name, version, document_id) {
                this.name = name
                this.version = version + 1
                this.showModal = true
                this.previous_document_id = document_id
            },
            async saveDocument() {
                this.working = true
                var formdata = { 
                    client_id: this.$route.params.id,
                    name : this.name,
                    version: this.version,
                    client_individual_id : this.client_individual.id,
                    previous_document_id: this.previous_document_id
                }; 

                BookingService.saveDocument(this.accessToken, formdata)
                .then((response) => {
                    this.closeModal();
                    console.log(response)
                    this.working = false
                    this.getClientIndividual();
                    this.showModal = false;
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },
            async updateClient() {
                this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        name: this.client.name,
                        code: this.client.code,
                        cost_centre: this.client.cost_centre,
                        default_break: this.client.default_break,
                        client_group_id: this.client.client_group_id,
                        client_group_billing_profile_id: this.client.client_group_billing_profile_id,
                        address1: this.client.address1,
                        address2: this.client.address2,
                        address3: this.client.address3,
                        city: this.client.city,
                        postcode: this.client.postcode,
                        break_notes: this.client.break_notes
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.getClient();
                            alert("Client Updated")
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
            },
            async removeClient() {
                if(confirm('Are you sure you want to remove this client from the database ?'))
                {
                    this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        active:0
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.$router.push("/billing/client-groups/" + this.client.client_group_id);
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
                }
                else {
                    return false
                }
            },
            async hideClient() {
                if(confirm('Are you sure you want to hide this client in the database ? It will remain visible in the  admin areas but no bookings can be added for it.'))
                {
                    this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        hide_client:1
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.$router.push("/billing/client-groups/" + this.client.client_group_id);
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
                }
                else {
                    return false
                }
            },
           
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getClientIndividual();
                this.getUserSelf()
                
            });
        
        },
        watch: {
           
           
        },
    }
</script>